import { useMemo as d } from "react";
import { useGetCategories as m } from "./index.es387.js";
const C = ["Region"], f = (i, s, n = !1) => {
  if (i === null)
    return 1;
  if (s === null)
    return -1;
  const e = n ? i : i.toLowerCase(), l = n ? s : s.toLowerCase();
  return e.localeCompare(l.toLowerCase());
}, v = (i) => {
  var s;
  const n = (s = i.children) == null ? void 0 : s.map((e) => {
    var l;
    const u = (l = e.children) == null ? void 0 : l.map((c) => c).sort(
      (c, h) => f(c.label, h.label)
    );
    return {
      ...e,
      children: u
    };
  }).sort((e, l) => f(e.label, l.label));
  return {
    ...i,
    children: n
  };
};
function g(i) {
  const s = [];
  return i.forEach((n) => {
    var e;
    if (n.type === "sub_category")
      (e = n.sections) != null && e.includes("property") && s.push(n);
    else if (Array.isArray(n.children)) {
      const l = g(n.children);
      l.length && s.push({
        ...n,
        children: l
      });
    }
  }), s;
}
const S = ({
  environment: i,
  token: s
}) => {
  const { data: n } = m({ environment: i, token: s }), e = d(() => {
    const t = ((n == null ? void 0 : n.category_data) || []).map((r) => v(r)).sort((r, o) => f(r.label, o.label));
    return g(t);
  }, [n]), l = d(() => e.flatMap((t) => t.children), [e]), u = d(() => e.reduce((t, r) => {
    if (C.includes(r.label)) {
      const o = r.children || [];
      t = [
        ...t,
        ...o.map((a) => a.label)
      ];
    }
    return t;
  }, []), [e]), c = d(() => u.length ? l.reduce((t, r) => {
    if (r && u.includes(r.label)) {
      const o = r.children || [];
      t = [...t, ...o.map((a) => a.label)];
    }
    return t;
  }, []) : [], [u, l]), h = d(() => {
    const t = e.reduce((r, o) => {
      if (o.label === "Shopping Centers") {
        const a = o.children || [];
        r = [...r, ...a.map((b) => b.label)];
      }
      return r;
    }, []);
    return new Set(
      l.reduce((r, o) => {
        if (o && t.includes(o.label)) {
          const a = (o == null ? void 0 : o.children) || [];
          r = [...r, ...a.map((b) => b.label)];
        }
        return r;
      }, [])
    );
  }, [e, l]), p = d(() => e.filter((t) => !C.includes(t.label)), [e]);
  return {
    categoriesData: e,
    filteredCategoriesData: p,
    excludedGroupCategories: C,
    excludedCategories: u,
    excludedSubGroupCategories: c,
    shoppingCenterSubCategoriesLookup: h
  };
};
export {
  S as useGisCategories
};
//# sourceMappingURL=index.es177.js.map
